import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination";
import Heading from '../../../../common/element/Heading';
import ClientInput from "../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import AdhocCompanyList from './adhocCompany';
import AddEditAdhocCompany from './addEdit';

// Redux Imports
import { getCompanyAdhocListing } from '../../../../redux/AdhocCompany/Companyadhocslice';
import {
  selectCompanyAdhocList,
  selectCompanyAdhocListTotal,
  selectCompanyAdhocListLoading
} from '../../../../redux/AdhocCompany/Companyadhocselectors';
import StatusSelect from '../../../../common/element/StatusSelect/StatusSelect';

const AdhocCompany = () => {
  const dispatch = useDispatch();

  // Redux State
  const adhocData = useSelector(selectCompanyAdhocList);
  const totalCount = useSelector(selectCompanyAdhocListTotal);
  const loading = useSelector(selectCompanyAdhocListLoading);
  console.log(adhocData, "adhocDataadhocDataadhocData")
  // Local State
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [status, setStatus] = useState("false");

  const [getFilterData, SetFilterData] = useState({
    search: "",
    sort: "created_date", // Optional: pass this to API if supported
    order: "desc",        // Optional: pass this to API if supported
  });

  // 1. Breadcrumbs
  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        { label: "Adhoc Company", url: "/adhoc-company", home: "/dashboard" },
      ])
    );
  }, [dispatch]);

  // 2. Fetch Data from API
  const fetchData = useCallback(() => {
    dispatch(getCompanyAdhocListing({
      page: filterpage,
      limit: filterlimit,
      search: getFilterData.search,
      is_archived: status
    }));
  }, [dispatch, filterpage, filterlimit, getFilterData.search, status]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // 3. Handle Total Pages Calculation
  useEffect(() => {
    if (totalCount && filterlimit) {
      setTotalPages(Math.ceil(totalCount / filterlimit));
    } else {
      setTotalPages(1);
    }
  }, [totalCount, filterlimit]);

  // 4. Handle Search
  const handleSearch = (e) => {
    SetFilterData((prevalue) => ({
      ...prevalue,
      [e.target.name]: e.target.value.trim(),
    }));
    setfilterpage(1); // Reset to page 1 on search
  };

  const inputchangehandler = useCallback(debounce(handleSearch, 500), []);

  // 5. Handlers
  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  const handleRefresh = () => {
    fetchData();
  };

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3"></p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="w-80 h-10 text-start">
          <Heading>Adhoc Company</Heading>
        </div>

        <div className="flex gap-2">
          <BtnPrimary
            onClick={() => setDialogOpen(true)}
            className="text-xs h-9 flex items-center justify-center px-3 gap-1"
            style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
          >
            Add Adhoc Company
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.712 4.167v11.666M4.878 10h11.667" stroke="#fff" strokeWidth="1.667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </BtnPrimary>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <div className='me-3'>
          <StatusSelect
            value={status}
            onChange={(val) => {
              setStatus(val);
            }}
            placeholder="Select Status"
          />
        </div>
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img src="/assets/icons-svg/search-lg.svg" alt="" className="h-5" />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>

      {/* Pass Redux Data to List Component */}
      <AdhocCompanyList
        data={adhocData}
        loading={loading}
        page={filterpage}
        limit={filterlimit}
        onRefresh={handleRefresh}
      />

      <AddEditAdhocCompany
        dialogOpen={dialogOpen}
        onDialogClose={() => {
          setDialogOpen(false);
          fetchData(); // Refresh list after add
        }}
      />

      <div className="flex justify-between items-center mt-3">
        {/* Left side - Pagination info */}
        <Pagination
          totalCount={totalCount}
          pageNumber={filterpage}
          displayPage={adhocData?.length}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {/* Right side - Modern Pagination Controls */}
        {totalCount > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default AdhocCompany;